import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyC5bg4RxA6LzOXqpuw-b-m7l8Te7biWxj0",
    authDomain: "ey---cadastro-de-sinistro.firebaseapp.com",
    projectId: "ey---cadastro-de-sinistro",
    storageBucket: "ey---cadastro-de-sinistro.appspot.com",
    messagingSenderId: "385290944031",
    appId: "1:385290944031:web:1a7ca19cdce28f5acf1f2a",
    measurementId: "G-7JV5MQRF57"
};

export const app = initializeApp(firebaseConfig);
